module.exports = __webpack_public_path__ + "static/media/bimobject.86e067d5.svg";